export enum CompanyTab {
  SUMMARY = 0,
  SPEND = 1,
  INSTALL = 2,
  INTENT = 3,
  CONTRACT = 4,
}

export const TAB_DEFINITIONS = {
  [CompanyTab.SUMMARY]: {
    label: "SUMMARY",
    path: "",
  },
  [CompanyTab.SPEND]: {
    label: "SPEND",
    path: "/spend",
  },
  [CompanyTab.INSTALL]: {
    label: "INSTALL",
    path: "/install",
  },
  [CompanyTab.INTENT]: {
    label: "INTENT",
    path: "/intent",
  },
  [CompanyTab.CONTRACT]: {
    label: "CONTRACT",
    path: "/contract",
  },
} as const;
